export default __webpack_public_path__ + "static/media/BM_RenderCamera_15_BalconyB+Interior+Light_Scheme.9452d1ef.jpg";